import { memo } from "react";
import { Box, Radio, Typography } from "@mui/material";

const MCQAnswer = memo(function MCQAnswer({ selectedValue, handleChange, options, isMock, answerScrollRef }) {
  return (
    <Box
      ref={answerScrollRef}
      sx={{
        flex: "1 1 0",
        minHeight: 0,
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#e0e0e0",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "blue",
          borderRadius: "10px",
          border: "2px solid #e0e0e0",
          height: "10px",
          paddingBottom: "5px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "darkblue",
        },
      }}
    >
      {options?.map((q, i) => (
        <Box
          key={i}
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "14px",
          }}
        >
          <Radio
            checked={Number(selectedValue) === i + 1}
            onChange={(e) => handleChange(e)}
            value={i + 1}
            name="questionOptions"
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 18,
              },
            }}
          />
          {isMock && (
            <Typography
              sx={{ textWrap: "nowrap", cursor: "pointer" }}
              onClick={() =>
                handleChange({ target: { value: String(i + 1) } })
              }
            >
              {`Option ${String.fromCharCode(65 + i)}`}
            </Typography>
          )}
          <img
            src={q}
            style={{
              height: "auto",
              width: isMock ? "85%" : "65%",
            }}
            alt={`option-${i}`}
          />
        </Box>
      ))}
    </Box>
  );
});

export default MCQAnswer;